import { render, staticRenderFns } from "./SubProgramSettingsPane.vue?vue&type=template&id=6c038d1b&scoped=true&"
import script from "./SubProgramSettingsPane.vue?vue&type=script&lang=js&"
export * from "./SubProgramSettingsPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c038d1b",
  null
  
)

export default component.exports